const API_BASE = (
  import.meta.env.VITE_INTAKE_API_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  ""
).replace(/\/$/, "");

// True when we're pointed at the dev intake API. Drives the dev template
// override (the prod portfolio templates don't exist in the dev CoPilot
// account) both for the Auto default below and for the sales-code -> template
// pairing in lib/salesCode.ts.
export const IS_DEV_API = API_BASE.includes("dev");
